import type { FormatDateExpression } from '@trackback/widgets';
import { createSimpleNamedObservableExpressionResolver } from '../types';
import { Observable } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { parseISO, format as formatLocal } from 'date-fns';
import { format, utcToZonedTime } from 'date-fns-tz';
import locales from '../../models/date-fns-locales';

// See https://github.com/date-fns/date-fns/blob/main/docs/unicodeTokens.md for problem with mismatching tokens in MomentJS
export const createFormatDateResolver = (currentLocale$: Observable<string>) =>
  createSimpleNamedObservableExpressionResolver<FormatDateExpression>(
    'formatDate',
    (utcDate, formatString, useLocalTimezone) =>
      currentLocale$.pipe(
        distinctUntilChanged(),
        map(locale => {
          const date =
            typeof utcDate === 'string' ? parseISO(utcDate) : new Date(utcDate);
          const formatStringReplaced = formatString
            .replace(/D/g, 'd')
            .replace(/Y/g, 'y');
          if (useLocalTimezone) {
            return formatLocal(date, formatStringReplaced, {
              locale: locales[locale],
            });
          }
          return format(utcToZonedTime(date, 'UTC'), formatStringReplaced, {
            locale: locales[locale],
            timeZone: 'UTC',
          });
        })
      )
  );
